import { render, staticRenderFns } from "./HomeworkPlaningWidget.vue?vue&type=template&id=7aa9523d"
import script from "./HomeworkPlaningWidget.vue?vue&type=script&lang=js"
export * from "./HomeworkPlaningWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports